import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import symbole from './symbole.html?raw';
import { App } from './App';
import './styles.css';
import './ergaenzungen.css';

// Hell oder dunkel vor dem ersten Bild: zuletzt gewählte Ansicht, sonst dunkel (Leon 2026-10-28); je Person merkt sie sich der Rahmen.
// Neuer Schlüssel: unter „nt-theme“ steht bei allen bisherigen Nutzern noch der alte Standard hell.
try { document.documentElement.dataset.theme = localStorage.getItem('nt-ansicht') === 'light' ? 'light' : 'dark'; } catch { document.documentElement.dataset.theme = 'dark'; }

// Symbolsatz des Prototyps einmal in die Seite
document.body.insertAdjacentHTML('afterbegin', symbole);

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
